import React from 'react';
import { GlobalStyles } from '@mui/material';

const globalStyles = {
  html: {
    height: '100%',
  },
  body: {
    margin: 0,
    minHeight: '100%',
    backgroundColor: '#f5f7fb',
  },
  '#root': {
    minHeight: '100vh',
  },
  a: {
    color: 'inherit',
  },
  '.swal2-container': {
    zIndex: '1600 !important',
  },
  '.open-form-page': {
    minHeight: '100vh',
    margin: '40px 0 0 240px',
    padding: '50px 48px 56px',
    background: '#ffffff',
    color: '#183a7a',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  },
  '.open-form-page.open-form-page-embedded': {
    minHeight: 'auto',
    margin: 0,
    padding: '8px 16px 24px',
  },
  '.open-form-steps': {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
    gap: '6px',
    marginBottom: '25px',
  },
  '.open-form-step': {
    position: 'relative',
    border: 'none',
    padding: '14px 16px 14px 24px',
    background: '#eef0f4',
    color: '#25437d',
    fontSize: '15px',
    cursor: 'default',
    clipPath: 'polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%, 18px 50%)',
  },
  '.open-form-step:first-of-type': {
    clipPath: 'polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%, 0 50%)',
    borderTopLeftRadius: '999px',
    borderBottomLeftRadius: '999px',
  },
  '.open-form-step:last-of-type': {
    borderTopRightRadius: '999px',
    borderBottomRightRadius: '999px',
  },
  '.open-form-step.active': {
    background: '#16559d',
    color: '#fff',
    cursor: 'pointer',
  },
  '.open-form-step.active:first-of-type::before': {
    content: '""',
    position: 'absolute',
    left: '0',
    top: '0',
    width: '24px',
    height: '100%',
    background: '#e81d2d',
    borderTopLeftRadius: '999px',
    borderBottomLeftRadius: '999px',
  },
  '.open-form-step.done': {
    background: '#dbe8fb',
    color: '#16559d',
    cursor: 'pointer',
  },
  '.open-form-step span': {
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  '.open-form-body': {
    maxWidth: '1160px',
  },
  '.open-form-page.open-form-page-embedded .open-form-body': {
    maxWidth: '100%',
  },
  '.open-form-card': {
    padding: '8px 80px 0 80px',
  },
  '.open-form-page.open-form-page-embedded .open-form-card': {
    padding: '8px 24px 0',
  },
  '.open-form-page.open-form-page-embedded .open-form-steps': {
    marginBottom: '16px',
    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
    gap: '0px',
  },
  '.open-form-page.open-form-page-embedded .open-form-step': {
    fontSize: '12px',
    padding: '11px 8px 11px 16px',
    marginLeft: 0,
  },
  '.open-form-page.open-form-page-embedded .open-form-step span': {
    whiteSpace: 'nowrap',
  },
  '.open-form-question': {
    marginBottom: '20px',
  },
  '.open-form-question-title': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
    color: '#173971',
    fontSize: '16px',
    fontWeight: 600,
  },
  '.open-form-question-title svg': {
    color: '#7f8799',
    fontSize: '14px',
  },
  '.open-form-tooltip-trigger': {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'help',
  },
  '.open-form-tooltip-panel': {
    position: 'absolute',
    top: 'calc(100% + 10px)',
    left: '50%',
    zIndex: 20,
    minWidth: '220px',
    maxWidth: '320px',
    padding: '12px 14px',
    border: '1px solid #cfd9ea',
    borderRadius: '10px',
    background: '#ffffff',
    boxShadow: '0 14px 32px rgba(20, 56, 118, 0.16)',
    color: '#183a7a',
    fontSize: '13px',
    lineHeight: 1.5,
    opacity: 0,
    visibility: 'hidden',
    transform: 'translateX(-50%) translateY(6px)',
    transition: 'opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease',
  },
  '.open-form-tooltip-panel::before': {
    content: '""',
    position: 'absolute',
    top: '-7px',
    left: '50%',
    width: '12px',
    height: '12px',
    borderTop: '1px solid #cfd9ea',
    borderLeft: '1px solid #cfd9ea',
    background: '#ffffff',
    transform: 'translateX(-50%) rotate(45deg)',
  },
  '.open-form-tooltip-trigger:hover .open-form-tooltip-panel, .open-form-tooltip-trigger:focus-within .open-form-tooltip-panel': {
    opacity: 1,
    visibility: 'visible',
    transform: 'translateX(-50%) translateY(0)',
  },
  '.open-form-tooltip-panel-wide': {
    minWidth: '320px',
    maxWidth: '420px',
  },
  '.open-form-tooltip-list': {
    margin: 0,
    paddingLeft: '18px',
  },
  '.open-form-tooltip-list li + li': {
    marginTop: '4px',
  },
  '.open-form-radio-group': {
    display: 'flex',
    alignItems: 'center',
    gap: '34px',
    flexWrap: 'wrap',
  },
  '.open-form-radio': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
    color: '#1f4182',
    fontSize: '14px',
  },
  '.open-form-radio input': {
    width: '18px',
    height: '18px',
    accentColor: '#2e6fc4',
  },
  '.open-form-alert-copy': {
    maxWidth: '1080px',
    margin: '0 0 40px',
    color: '#183a7a',
    fontSize: '15px',
    lineHeight: 1.6,
  },
  '.open-form-alert-copy a': {
    color: '#2b6dc1',
    fontWeight: 700,
    textDecoration: 'none',
  },
  '.open-form-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '20px 16px',
    marginBottom: '20px',
  },
  '.open-form-grid-three': {
    gridTemplateColumns: '1.2fr 0.7fr 1fr',
  },
  '.open-form-grid-four': {
    gridTemplateColumns: '0.65fr 1.3fr 1fr 1fr',
  },
  '.open-form-grid-contact': {
    gridTemplateColumns: '1.3fr 0.75fr',
  },
  '.open-form-grid-date-time': {
    gridTemplateColumns: '1fr 0.5fr',
  },
  '.open-form-grid-vehicle-four': {
    gridTemplateColumns: '1.2fr 0.8fr 1.2fr 0.8fr',
  },
  '.open-form-grid-vehicle-three': {
    gridTemplateColumns: '0.85fr 0.85fr 1.3fr',
  },
  '.open-form-grid-vehicle-contact': {
    gridTemplateColumns: '1fr 0.55fr 1.2fr',
  },
  '.open-form-grid-license': {
    gridTemplateColumns: '1.3fr 0.65fr 1fr',
  },
  '.open-form-field': {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  '.open-form-field-full': {
    gridColumn: '1 / -1',
    maxWidth: 'calc(50% - 8px)',
  },
  '.open-form-field-half-row': {
    gridColumn: '1 / -1',
    maxWidth: 'calc(50% - 8px)',
  },
  '.open-form-field-textarea': {
    marginBottom: '20px',
  },
  '.open-form-vehicle-card': {
    border: '1px solid #d8deea',
    borderRadius: '4px',
    paddingTop: 0,
    overflow: 'hidden',
  },
  '.open-form-vehicle-tabs': {
    margin: '0 0 28px',
    borderBottom: '1px solid #d8deea',
    background: '#ffffff',
  },
  '.open-form-vehicle-tab-list': {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  '.open-form-vehicle-tab': {
    minWidth: '194px',
    padding: '18px 26px',
    border: 'none',
    background: '#1766b0',
    color: '#ffffff',
    fontSize: '14px',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(23, 102, 176, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  '.open-form-vehicle-tab-subtitle': {
    fontSize: '15px',
  },
  '.open-form-add-vehicle-btn': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '158px',
    padding: '12px 22px',
    border: 'none',
    borderRadius: '4px',
    background: '#1766b0',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  '.open-form-add-vehicle-btn:disabled': {
    background: '#9aa7b8',
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  '.open-form-add-vehicle-footer': {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '22px',
  },
  '.open-form-delete-vehicle-wrap': {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '12px',
    paddingRight: '20px',
  },
  '.open-form-delete-vehicle-btn': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '176px',
    padding: '12px 20px',
    border: 'none',
    borderRadius: '4px',
    background: '#c62828',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  '.open-form-field label': {
    color: '#1a3a73',
    fontSize: '14px',
  },
  '.open-form-field .required': {
    color: '#ef1b2d',
    fontWeight: 700,
  },
  '.required:not(.mandatory-required)': {
    display: 'none',
  },
  '.mandatory-required': {
    color: '#ef1b2d',
    fontWeight: 700,
  },
  '.open-form-field input, .open-form-field select, .open-form-field textarea': {
    minHeight: '44px',
    padding: '0 14px',
    border: '1px solid #d8deea',
    borderRadius: '7px',
    background: '#fff',
    color: '#173971',
    fontSize: '15px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  '.open-form-field textarea': {
    minHeight: '150px',
    resize: 'vertical',
    lineHeight: 1.5,
    paddingTop: '12px',
    paddingBottom: '12px',
  },
  '.open-form-field input.has-error, .open-form-field select.has-error, .open-form-field textarea.has-error': {
    borderColor: '#ef1b2d',
  },
  '.open-form-datetime-zone-control': {
    display: 'grid',
    gridTemplateColumns: 'minmax(210px, 1fr) 104px',
    gap: 0,
    alignItems: 'stretch',
  },
  '.open-form-datetime-zone-control .open-form-datepicker-wrapper': {
    width: '100%',
  },
  '.open-form-datetime-zone-control .open-form-datepicker-input-shell': {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  '.open-form-datetime-zone-control > input': {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  '.open-form-datetime-zone-control select': {
    minWidth: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: 0,
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  '.open-form-help-text': {
    margin: '6px 0 0',
    color: '#27447a',
    fontSize: '13px',
  },
  '.open-form-inline-radio-block': {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    flexWrap: 'wrap',
  },
  '.open-form-inline-error': {
    color: '#ff2f2f',
    fontSize: '13px',
  },
  '.open-form-passenger-list': {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },
  '.open-form-passenger-card': {
    border: '1px solid #d8deea',
    borderRadius: '4px',
    padding: '0 14px 18px',
  },
  '.open-form-passenger-header': {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '0 -14px 18px',
    borderBottom: '1px solid #d8deea',
  },
  '.open-form-passenger-tab': {
    minWidth: '128px',
    padding: '12px 18px',
    border: 'none',
    background: '#1766b0',
    color: '#fff',
    fontSize: '15px',
    cursor: 'pointer',
  },
  '.open-form-add-passenger-btn': {
    minWidth: '132px',
    fontSize: '15px',
    padding: '10px 16px',
  },
  '.open-form-additional-stack': {
    marginBottom: '12px',
  },
  '.open-form-doc-section': {
    marginBottom: '15px',
  },
  '.open-form-doc-intro': {
    margin: '0 0 18px',
    color: '#173971',
    fontSize: '15px',
  },
  '.open-form-doc-list-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '24px',
  },
  '.open-form-doc-list': {
    margin: 0,
    paddingLeft: '22px',
    color: '#173971',
  },
  '.open-form-doc-list li + li': {
    marginTop: '14px',
  },
  '.open-form-doc-note': {
    margin: '0 0 26px',
    color: '#173971',
    fontSize: '14px',
    fontStyle: 'italic',
    lineHeight: 1.6,
  },
  '.open-form-field-hint': {
    display: 'block',
    marginTop: '6px',
    color: '#64748b',
    fontSize: '12px',
    lineHeight: 1.4,
  },
  '.open-form-upload-box': {
    minHeight: '124px',
    marginBottom: '12px',
    padding: '18px 20px',
    border: '1px dashed #d8deea',
    borderRadius: '4px',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    flexWrap: 'wrap',
  },
  '.open-form-upload-btn': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 18px',
    border: '1px solid #d8deea',
    borderRadius: '4px',
    background: '#fff',
    color: '#1766b0',
    fontSize: '15px',
    cursor: 'pointer',
  },
  '.open-form-upload-hint': {
    color: '#173971',
    fontSize: '15px',
  },
  '.open-form-uploaded-files': {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '12px',
  },
  '.open-form-uploaded-file': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '10px 12px',
    border: '1px solid #d8deea',
    borderRadius: '8px',
    background: '#fff',
    color: '#173971',
    fontSize: '14px',
  },
  '.open-form-uploaded-file span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '.open-form-uploaded-file .open-form-delete-vehicle-btn': {
    minWidth: 'auto',
    padding: '8px 12px',
    fontSize: '13px',
    flexShrink: 0,
  },
  '.open-form-uploaded-file .open-form-delete-vehicle-btn.view-file': {
    background: '#2e7d32',
  },
  '.open-form-uploaded-file .open-form-delete-vehicle-btn.view-file:hover': {
    background: '#1b5e20',
  },
  '.open-form-uploaded-file .open-form-delete-vehicle-btn.download-file': {
    background: '#1766b0',
  },
  '.open-form-uploaded-file .open-form-delete-vehicle-btn.download-file:hover': {
    background: '#0d4f8b',
  },
  '.open-form-doc-toggle': {
    width: '100%',
    marginBottom: '8px',
    padding: '14px 18px',
    border: '0',
    borderRadius: '4px',
    background: '#fff',
    color: '#1766b0',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
  },
  '.open-form-doc-toggle-icon': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
  },
  '.open-form-doc-definitions': {
    marginBottom: '12px',
    color: '#173971',
    fontSize: '15px',
    lineHeight: 1.6,
  },
  '.open-form-doc-definitions p': {
    margin: '0 0 14px',
  },
  '.open-form-doc-checkbox': {
    marginBottom: '25px',
  },
  '.open-form-fraud-warning': {
    margin: 0,
    color: '#173971',
    fontSize: '14px',
    lineHeight: 1.65,
  },
  '.open-form-tooltip-copy': {
    display: 'block',
  },
  '.open-form-tooltip-copy-spaced': {
    marginTop: '8px',
  },
  '.open-form-question-compact': {
    marginBottom: '18px',
  },
  '.open-form-section-heading': {
    margin: '6px 0 14px',
    color: '#173971',
    fontSize: '14px',
    fontWeight: 600,
  },
  '.open-form-checkbox': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    color: '#1f4182',
    fontSize: '15px',
    cursor: 'pointer',
  },
  '.open-form-checkbox input': {
    width: '16px',
    height: '16px',
    accentColor: '#2e6fc4',
  },
  '.open-form-checkbox-block': {
    marginBottom: '12px',
  },
  '.open-form-character-count': {
    marginTop: '6px',
    textAlign: 'right',
    color: '#27447a',
    fontSize: '12px',
  },
  '.open-form-location-map-grid': {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: '18px',
    alignItems: 'stretch',
    margin: '8px 0 22px',
  },
  '.open-form-location-coordinates': {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '14px',
    alignContent: 'start',
  },
  '.open-form-map-wrap': {
    position: 'relative',
    minHeight: '280px',
    margin: 0,
    border: '1px solid #d8deea',
    borderRadius: '7px',
    overflow: 'hidden',
    background: '#f6f8fc',
  },
  '.open-form-map': {
    width: '100%',
    height: '320px',
  },
  '.open-form-map-status': {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    color: '#27447a',
    fontSize: '14px',
    textAlign: 'center',
    background: 'rgba(246, 248, 252, 0.82)',
  },
  '.open-form-impact-field': {
    gap: '10px',
  },
  '.open-form-impact-selector': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  '.open-form-impact-diagram': {
    position: 'relative',
    width: '100%',
    maxWidth: '720px',
    aspectRatio: '248 / 177',
    border: '1px solid #b8c6df',
    background: '#ffffff',
    overflow: 'hidden',
    padding: '18px',
    boxSizing: 'border-box',
  },
  '.open-form-impact-car': {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    background: '#ffffff',
  },
  '.open-form-impact-point': {
    position: 'absolute',
    width: '28px',
    height: '28px',
    padding: 0,
    border: '1px solid #a9c5f5',
    background: '#ffffff',
    color: '#1766b0',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
  },
  '.open-form-impact-point input': {
    width: '14px',
    height: '14px',
    margin: 0,
    accentColor: '#2f6fd0',
    pointerEvents: 'none',
  },
  '.open-form-impact-point:hover, .open-form-impact-point:focus-visible': {
    outline: '2px solid #2f6fd0',
    outlineOffset: '1px',
  },
  '.open-form-impact-point.selected': {
    background: '#ffffff',
    borderColor: '#2f6fd0',
  },
  '.open-form-impact-summary': {
    maxWidth: '760px',
    padding: '10px 12px',
    border: '1px solid #d8deea',
    background: '#f8fbff',
    color: '#173971',
    fontSize: '14px',
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  '.open-form-impact-summary span': {
    color: '#27447a',
    display: 'inline-flex',
    gap: '3px',
  },
  '.open-form-impact-modal': {
    position: 'fixed',
    inset: 0,
    zIndex: 1500,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '96px 16px 24px',
    background: 'rgba(15, 32, 60, 0.18)',
  },
  '.open-form-impact-popover': {
    position: 'relative',
    width: '370px',
    maxWidth: 'calc(100vw - 32px)',
    padding: '12px 12px 14px',
    border: '1px solid #6a94d8',
    background: '#eaf3ff',
    boxShadow: '0 2px 8px rgba(20, 56, 118, 0.28)',
    color: '#173971',
  },
  '.open-form-impact-popover::after': {
    content: '""',
    position: 'absolute',
    right: '34px',
    bottom: '-8px',
    width: '14px',
    height: '14px',
    borderRight: '1px solid #6a94d8',
    borderBottom: '1px solid #6a94d8',
    background: '#eaf3ff',
    transform: 'rotate(45deg)',
  },
  '.open-form-impact-popover .open-form-field': {
    gap: '4px',
    marginBottom: '0',
  },
  '.open-form-impact-popover .open-form-field + .open-form-field': {
    marginTop: '4px',
  },
  '.open-form-impact-popover select': {
    minHeight: '32px',
  },
  '.open-form-impact-popover textarea': {
    minHeight: '68px',
  },
  '.open-form-impact-actions': {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '12px',
  },
  '.open-form-impact-actions .open-form-nav-btn': {
    minWidth: '82px',
    padding: '8px 14px',
    borderRadius: '4px',
  },
  '.open-form-authority-header, .open-form-authority-row': {
    display: 'grid',
    gridTemplateColumns: '1.3fr 1fr 1fr',
    gap: '8px',
    alignItems: 'center',
  },
  '.open-form-authority-header': {
    marginBottom: '8px',
    color: '#1a3a73',
    fontSize: '14px',
    fontWeight: 600,
  },
  '.open-form-authority-list': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  '.open-form-authority-row .open-form-checkbox': {
    fontSize: '14px',
  },
  '.open-form-authority-row .open-form-field': {
    gap: 0,
  },
  '.open-form-placeholder': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    alignItems: 'flex-start',
    paddingTop: '24px',
  },
  '.open-form-placeholder h3': {
    margin: 0,
    fontSize: '22px',
    color: '#173971',
  },
  '.open-form-placeholder p, .open-form-placeholder span': {
    margin: 0,
    fontSize: '15px',
    color: '#3f5f97',
  },
  '.open-form-footer': {
    display: 'flex',
    justifyContent: 'center',
    gap: '36px',
    marginTop: '44px',
  },
  '.open-form-upload-progress': {
    width: 'min(680px, 100%)',
    margin: '32px auto 0',
    padding: '16px 18px',
    border: '1px solid rgba(47, 111, 208, 0.22)',
    borderRadius: '12px',
    background: 'rgba(47, 111, 208, 0.06)',
  },
  '.open-form-upload-progress-copy': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
    marginBottom: '10px',
    color: '#173971',
    fontSize: '13px',
  },
  '.open-form-upload-progress-copy span': {
    color: '#526987',
    whiteSpace: 'nowrap',
  },
  '.open-form-upload-progress-track': {
    height: '10px',
    overflow: 'hidden',
    borderRadius: '999px',
    background: '#dbe7f8',
  },
  '.open-form-upload-progress-track span': {
    display: 'block',
    height: '100%',
    borderRadius: 'inherit',
    background: 'linear-gradient(90deg, #2f6fd0, #4f91ee)',
    transition: 'width 180ms ease',
  },
  '.open-form-nav-btn': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    minWidth: '126px',
    padding: '12px 22px',
    borderRadius: '999px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  '.open-form-nav-btn.secondary': {
    border: '1px solid #2f6fd0',
    background: '#fff',
    color: '#2f6fd0',
  },
  '.open-form-nav-btn.primary': {
    border: 'none',
    background: '#2f6fd0',
    color: '#fff',
  },
  '.open-form-nav-btn:disabled': {
    opacity: 0.45,
    cursor: 'not-allowed',
  },
  '.ra-error': {
    background: 'rgba(255,107,107,0.1)',
    border: '1px solid rgba(255,107,107,0.3)',
    color: '#c62828',
    borderRadius: '8px',
    padding: '10px 16px',
    fontSize: '13px',
    marginBottom: '16px',
  },
  '.ra-success': {
    background: 'rgba(74,222,128,0.12)',
    border: '1px solid rgba(74,222,128,0.3)',
    color: '#167a3f',
    borderRadius: '8px',
    padding: '10px 16px',
    fontSize: '13px',
    marginBottom: '16px',
  },
  '.ra-badge-yes, .ra-badge-no, .ra-status-open, .ra-status-closed': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '.ra-badge-yes': {
    background: 'rgba(74,222,128,0.12)',
    color: '#167a3f',
    border: '1px solid rgba(74,222,128,0.25)',
    borderRadius: '20px',
    padding: '2px 10px',
    fontSize: '11px',
    fontWeight: 600,
  },
  '.ra-badge-no': {
    background: 'rgba(255,107,107,0.1)',
    color: '#c62828',
    border: '1px solid rgba(255,107,107,0.2)',
    borderRadius: '20px',
    padding: '2px 10px',
    fontSize: '11px',
    fontWeight: 600,
  },
  '.ra-status-open, .ra-status-closed': {
    minWidth: '72px',
    borderRadius: '999px',
    padding: '4px 10px',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
  '.ra-status-open': {
    background: 'rgba(37, 99, 235, 0.12)',
    color: '#1d4ed8',
    border: '1px solid rgba(37, 99, 235, 0.22)',
  },
  '.ra-status-closed': {
    background: 'rgba(16, 185, 129, 0.12)',
    color: '#047857',
    border: '1px solid rgba(16, 185, 129, 0.22)',
  },
  '.ra-form-group-title': {
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
    color: '#4000ff',
    margin: '20px 0 12px',
    paddingBottom: '6px',
    borderBottom: '1px solid rgba(108,99,255,0.15)',
  },
  '.ra-modal-header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
  '.ra-modal-header h3': {
    fontSize: '18px',
    fontWeight: 700,
    margin: 0,
    color: '#000000',
  },
  '.ra-modal-subtitle': {
    margin: '6px 0 0',
    fontSize: '13px',
    color: '#4b5563',
  },
  '.ra-form-main': {
    minWidth: 0,
  },
  '.ra-form-shell': {
    display: 'grid',
    gridTemplateColumns: '240px minmax(0, 1fr)',
    gap: '20px',
    alignItems: 'start',
  },
  '.ra-form-sidecard': {
    background: 'linear-gradient(180deg, #eef2ff, #f8fafc)',
    border: '1px solid rgba(99, 102, 241, 0.16)',
    borderRadius: '16px',
    padding: '18px',
  },
  '.ra-sidecard-step': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '72px',
    height: '28px',
    padding: '0 12px',
    borderRadius: '999px',
    background: '#dbeafe',
    color: '#1d4ed8',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
  },
  '.ra-form-sidecard h4': {
    margin: '14px 0 8px',
    fontSize: '18px',
    color: '#111827',
  },
  '.ra-form-sidecard p': {
    margin: 0,
    fontSize: '13px',
    color: '#374151',
    lineHeight: 1.6,
  },
  '.ra-summary-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '12px',
  },
  '.ra-summary-card': {
    background: 'rgba(255,255,255,0.4)',
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: '12px',
    padding: '12px 14px',
  },
  '.ra-summary-card span': {
    display: 'block',
    fontSize: '11px',
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.7px',
    marginBottom: '6px',
  },
  '.ra-summary-card strong': {
    display: 'block',
    color: '#111827',
    fontSize: '13px',
    wordBreak: 'break-word',
  },
  '.ra-form-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '14px',
  },
  '.ra-form-grid.full': {
    gridTemplateColumns: '1fr',
  },
  '.ra-field': {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  '.ra-field label': {
    fontSize: '11.5px',
    fontWeight: 500,
    color: '#000',
    letterSpacing: '0.2px',
  },
  '.ra-field input, .ra-field select, .ra-field textarea': {
    background: 'rgba(255,255,255,0.85)',
    border: '1px solid #000',
    borderRadius: '8px',
    padding: '9px 12px',
    color: '#000',
    fontFamily: 'inherit',
    fontSize: '13px',
    outline: 'none',
    transition: 'border-color 0.18s, background 0.18s',
    width: '100%',
    boxSizing: 'border-box',
  },
  '.ra-input-error': {
    borderColor: '#ff6b6b !important',
    boxShadow: '0 0 0 1px rgba(255,107,107,0.18)',
  },
  '.ra-field textarea': {
    resize: 'vertical',
    minHeight: '72px',
  },
  '.ra-action-text': {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#4b5563',
    fontSize: '12px',
    fontWeight: 600,
    padding: '5px 0',
  },
  '.ra-nowrap-btn': {
    whiteSpace: 'nowrap !important',
    minWidth: 'fit-content !important',
    borderRadius: '999px !important',
    textTransform: 'none !important',
    lineHeight: '20px !important',
    padding: '6px 14px !important',
  },
  '.ra-claim-processing-btn': {
    minWidth: '148px !important',
  },
  '.ra-header-action-btn': {
    minWidth: '132px !important',
    height: '42px !important',
  },
  '.ra-header-action-btn.wide': {
    minWidth: '220px !important',
  },
  '.ra-nowrap-btn .MuiButton-startIcon': {
    marginRight: '8px !important',
  },
  '.ra-processing-badge': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '112px',
    height: '28px',
    padding: '0 12px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 800,
    whiteSpace: 'nowrap',
  },
  '.ra-processing-badge.yet-to-process': {
    background: '#f1f5f9',
    color: '#475569',
    border: '1px solid #cbd5e1',
  },
  '.ra-processing-badge.in-process': {
    background: '#eaf1ff',
    color: '#1d4ed8',
    border: '1px solid rgba(37, 99, 235, 0.24)',
  },
  '.ra-processing-badge.completed': {
    background: '#dcfce7',
    color: '#047857',
    border: '1px solid rgba(16, 185, 129, 0.28)',
  },
  '.ra-link-button': {
    border: 'none',
    background: 'transparent',
    color: '#2f6fd0',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 600,
    padding: 0,
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
  '.ra-notes-meta': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '12px',
    marginBottom: '18px',
  },
  '.ra-notes-meta div': {
    background: 'rgba(255,255,255,0.85)',
    border: '1px solid #000',
    borderRadius: '10px',
    padding: '12px 14px',
  },
  '.ra-notes-meta span': {
    display: 'block',
    fontSize: '11px',
    color: '#5d5d5d',
    marginBottom: '6px',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
  },
  '.ra-notes-meta strong': {
    color: '#000',
    fontSize: '14px',
  },
  '.ra-notes-textarea': {
    minHeight: '140px !important',
  },
  '.submitted-forms-master-tabs': {
    marginBottom: '16px',
    padding: '4px 10px',
    borderRadius: '8px !important',
    border: '1px solid #dbe3ef',
    boxShadow: '0 6px 18px rgba(15, 23, 42, 0.05) !important',
  },
  '.submitted-forms-master-tabs .MuiTab-root': {
    textTransform: 'none',
    fontWeight: '800',
    color: '#475569',
    minHeight: '48px',
  },
  '.submitted-forms-master-tabs .Mui-selected': {
    color: '#1d4ed8 !important',
  },
  '.claim-process-dialog': {
    width: 'calc(100vw - 28px)',
    maxWidth: '1620px',
    height: 'calc(100vh - 28px)',
    maxHeight: 'calc(100vh - 28px)',
    margin: '14px',
    borderRadius: '8px !important',
    overflow: 'hidden',
    background: '#ffffff',
  },
  '.claim-process-title': {
    padding: '24px 32px 18px !important',
    borderBottom: '1px solid #dbe3ef',
    background: '#ffffff',
  },
  '.claim-process-heading': {
    fontSize: '30px !important',
    lineHeight: '36px !important',
    fontWeight: '800 !important',
    color: '#101828',
    letterSpacing: '0 !important',
  },
  '.claim-process-subtitle': {
    marginTop: '8px !important',
    color: '#52627a',
    fontSize: '15px !important',
  },
  '.claim-process-location-chip': {
    background: '#eaf1ff !important',
    color: '#1e56c5 !important',
    fontWeight: '800 !important',
    height: '36px !important',
    borderRadius: '999px !important',
    padding: '0 8px !important',
  },
  '.claim-process-content': {
    background: '#f3f6fa !important',
    padding: '22px 32px 28px !important',
  },
  '.claim-process-layout': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '20px',
    alignItems: 'stretch',
  },
  '.claim-process-layout.document-only > .claim-process-panel:not(.claim-documents-panel)': {
    display: 'none',
  },
  '.ra-form-shell.document-only': {
    gridTemplateColumns: '1fr',
  },
  '.ra-form-shell.document-only > .ra-form-sidecard': {
    display: 'none',
  },
  '.ra-form-shell.document-only > .ra-form-main > :not(.claim-documents-section)': {
    display: 'none',
  },
  '.claim-process-layout-item': {
    display: 'flex',
  },
  '.claim-process-error': {
    background: '#fff1f2',
    border: '1px solid #fecdd3',
    color: '#be123c',
    borderRadius: '8px',
    padding: '10px 12px',
    marginBottom: '16px',
    fontSize: '13px',
    fontWeight: 700,
  },
  '.claim-process-panel': {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '22px !important',
    borderRadius: '8px !important',
    border: '1px solid #e1e8f2',
    boxShadow: '0 10px 26px rgba(15, 23, 42, 0.06) !important',
    background: '#ffffff !important',
  },
  '.claim-process-panel.compact': {
    paddingBottom: '18px !important',
  },
  '.claim-process-panel-head': {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '18px',
  },
  '.claim-process-panel-head span': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '999px',
    background: '#eaf1ff',
    color: '#1e56c5',
    fontSize: '12px',
    fontWeight: 800,
  },
  '.claim-process-panel-head h3': {
    margin: 0,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#113b7a',
    fontWeight: 800,
    letterSpacing: 0,
  },
  '.claim-process-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '14px',
    alignContent: 'start',
  },
  '.claim-process-field': {
    display: 'flex',
    flexDirection: 'column',
    gap: '7px',
    minWidth: 0,
  },
  '.claim-process-field.full, .claim-process-field-full': {
    gridColumn: '1 / -1',
  },
  '.claim-process-rich-editor': {
    background: '#ffffff',
    borderRadius: '8px',
  },
  '.claim-process-rich-editor .ql-toolbar.ql-snow': {
    border: '1px solid #c8d2e1',
    borderRadius: '8px 8px 0 0',
    fontFamily: 'inherit',
  },
  '.claim-process-rich-editor .ql-container.ql-snow': {
    height: 'auto',
    minHeight: '150px',
    border: '1px solid #c8d2e1',
    borderTop: 0,
    borderRadius: '0 0 8px 8px',
    fontFamily: 'inherit',
    fontSize: '14px',
  },
  '.claim-process-rich-editor .ql-editor': {
    minHeight: '150px',
    color: '#102447',
  },
  '.claim-process-rich-editor:focus-within': {
    boxShadow: '0 0 0 3px rgba(47, 111, 208, 0.14)',
  },
  '.claim-process-rich-content p': {
    margin: '0 0 6px',
  },
  '.claim-process-rich-content p:last-child': {
    marginBottom: 0,
  },
  '.claim-process-rich-editor + *': {
    clear: 'both',
  },
  '.claim-process-field-full + .claim-process-field-full': {
    marginTop: '6px',
  },
  '.claim-process-field span': {
    color: '#334260',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 800,
  },
  '.claim-process-field input, .claim-process-field select, .claim-process-field textarea': {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    border: '1px solid #c8d2e1',
    borderRadius: '8px',
    background: '#ffffff',
    color: '#102447',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '20px',
    padding: '10px 12px',
    outline: 'none',
    transition: 'border-color 0.18s, box-shadow 0.18s, background 0.18s',
  },
  '.claim-process-field input, .claim-process-field select': {
    height: '42px',
  },
  '.claim-process-field input[type="number"]': {
    MozAppearance: 'textfield',
    appearance: 'textfield',
  },
  '.claim-process-field input[type="number"]::-webkit-inner-spin-button, .claim-process-field input[type="number"]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '.claim-process-field textarea': {
    minHeight: '118px',
    resize: 'vertical',
  },
  '.claim-process-field input:focus, .claim-process-field select:focus, .claim-process-field textarea:focus': {
    borderColor: '#2f6fd0',
    boxShadow: '0 0 0 3px rgba(47, 111, 208, 0.14)',
  },
  '.claim-process-field input::placeholder, .claim-process-field textarea::placeholder': {
    color: '#7a8aa4',
  },
  '.claim-process-checklist': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '10px',
    alignContent: 'start',
  },
  '.claim-process-check-row': {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minHeight: '40px',
    padding: '9px 10px',
    borderRadius: '8px',
    border: '1px solid #e1e8f2',
    background: '#f8fbff',
    color: '#17345f',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
  },
  '.claim-process-check-row input': {
    width: '16px',
    height: '16px',
    flex: '0 0 auto',
    accentColor: '#2f6fd0',
  },
  '.claim-process-check-row span': {
    minWidth: 0,
    lineHeight: '18px',
  },
  '.claim-process-followups': {
    display: 'grid',
    gap: '10px',
    marginTop: '16px',
  },
  '.claim-process-followup-entry': {
    border: '1px solid #dbe3ef',
    borderRadius: '8px',
    background: '#f8fbff',
    padding: '12px',
  },
  '.claim-process-followup-entry div': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    alignItems: 'center',
    marginBottom: '8px',
  },
  '.claim-process-followup-entry strong': {
    color: '#102447',
    fontSize: '13px',
  },
  '.claim-process-followup-entry span': {
    color: '#64748b',
    fontSize: '12px',
    fontWeight: 700,
  },
  '.claim-process-followup-entry p': {
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: '#334260',
    fontSize: '14px',
    lineHeight: '20px',
  },
  '.claim-process-empty-log': {
    border: '1px dashed #c8d2e1',
    borderRadius: '8px',
    color: '#64748b',
    background: '#fbfdff',
    padding: '12px',
    fontSize: '13px',
    fontWeight: 700,
  },
  '.claim-process-actions': {
    borderTop: '1px solid #dbe3ef',
    padding: '12px 32px !important',
    background: '#ffffff',
  },
  '.claim-process-cancel, .claim-process-draft-save, .claim-process-save': {
    minWidth: '104px !important',
    borderRadius: '999px !important',
    textTransform: 'none !important',
    fontWeight: '800 !important',
  },
  '.claim-process-save': {
    background: '#2f6fd0 !important',
    color: '#ffffff !important',
    boxShadow: '0 8px 18px rgba(47, 111, 208, 0.24) !important',
  },
  '.claim-process-draft-save': {
    background: '#ffffff !important',
    borderColor: '#2f6fd0 !important',
    color: '#2f6fd0 !important',
  },
  '.claim-process-cancel': {
    background: '#ffffff !important',
    borderColor: '#dc2626 !important',
    color: '#dc2626 !important',
  },
  '@media (max-width: 1280px)': {
    '.open-form-step': {
      fontSize: '14px',
      marginLeft: '-16px',
    },
    '.open-form-card': {
      padding: '8px 24px 0',
    },
  },
  '@media (max-width: 960px)': {
    '.claim-process-dialog': {
      width: 'calc(100vw - 16px)',
      height: 'calc(100vh - 16px)',
      maxHeight: 'calc(100vh - 16px)',
      margin: '8px',
    },
    '.claim-process-title, .claim-process-content, .claim-process-actions': {
      paddingLeft: '18px !important',
      paddingRight: '18px !important',
    },
    '.claim-process-heading': {
      fontSize: '24px !important',
      lineHeight: '30px !important',
    },
    '.claim-process-grid, .claim-process-grid.payment': {
      gridTemplateColumns: '1fr',
    },
    '.claim-process-layout': {
      gridTemplateColumns: '1fr',
    },
    '.open-form-page': {
      marginLeft: 0,
      padding: '24px 16px 40px',
    },
    '.open-form-steps': {
      gridTemplateColumns: '1fr',
    },
    '.open-form-page.open-form-page-embedded .open-form-steps': {
      gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
    },
    '.open-form-step, .open-form-step:first-of-type': {
      clipPath: 'none',
      borderRadius: '16px',
      paddingLeft: '18px',
      marginLeft: 0,
    },
    '.open-form-page.open-form-page-embedded .open-form-step, .open-form-page.open-form-page-embedded .open-form-step:first-of-type': {
      clipPath: 'polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%, 18px 50%)',
      borderRadius: 0,
      paddingLeft: '18px',
    },
    '.open-form-page.open-form-page-embedded .open-form-step:first-of-type': {
      clipPath: 'polygon(0 0, calc(100% - 18px) 0, 100% 50%, calc(100% - 18px) 100%, 0 100%, 0 50%)',
      borderTopLeftRadius: '999px',
      borderBottomLeftRadius: '999px',
    },
    '.open-form-page.open-form-page-embedded .open-form-step:last-of-type': {
      borderTopRightRadius: '999px',
      borderBottomRightRadius: '999px',
    },
    '.open-form-page.open-form-page-embedded .open-form-step.active:first-of-type::before': {
      display: 'block',
    },
    '.open-form-step.active:first-of-type::before': {
      display: 'none',
    },
    '.open-form-grid, .open-form-grid-three, .open-form-grid-four, .open-form-grid-contact, .open-form-grid-date-time, .open-form-grid-vehicle-four, .open-form-grid-vehicle-three, .open-form-grid-vehicle-contact, .open-form-grid-license, .open-form-location-map-grid, .open-form-authority-header, .open-form-authority-row, .ra-form-grid, .ra-summary-grid, .ra-form-shell, .ra-notes-meta': {
      gridTemplateColumns: '1fr',
    },
    '.open-form-datetime-zone-control': {
      gridTemplateColumns: 'minmax(0, 1fr) 96px',
    },
    '.open-form-impact-diagram': {
      maxWidth: '100%',
    },
    '.open-form-impact-point': {
      width: '22px',
      height: '22px',
    },
    '.open-form-impact-point input': {
      width: '12px',
      height: '12px',
    },
    '.open-form-field-full, .open-form-field-half-row': {
      maxWidth: '100%',
    },
    '.open-form-vehicle-tab-list': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    '.open-form-vehicle-tab, .open-form-add-vehicle-btn': {
      width: '100%',
    },
    '.open-form-authority-header': {
      display: 'none',
    },
    '.open-form-doc-list-grid': {
      gridTemplateColumns: '1fr',
      gap: '12px',
    },
  },
};

export default function GlobalAppStyles() {
  return <GlobalStyles styles={globalStyles} />;
}
